import type { EmailStarterTemplate } from '../types'

/**
 * Heads-up that the next subscription charge is coming. Friendly, transparent,
 * gives the customer an easy path to manage their subscription.
 */
export const subscriptionRebillUpcomingStarter: EmailStarterTemplate = {
    id: 'subscription-rebill-upcoming',
    label: 'Renewal reminder',
    description:
        'Friendly heads-up before the next subscription charge with a self-serve link.',
    icon: 'CalendarClock',
    accent: '#0284c7',
    defaultSubject: 'Your subscription renews soon, {{ customerFirstName }}',
    defaultPreheader:
        'Heads-up: your plan will renew automatically. Review or pause anytime.',
    doc: {
        type: 'doc',
        content: [
            {
                type: 'heading',
                attrs: { level: 1, textAlign: 'left' },
                content: [{ type: 'text', text: 'Your subscription renews soon' }],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Hi ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'customerFirstName',
                            label: 'customerFirstName',
                            fallback: 'there',
                            required: false,
                        },
                    },
                    {
                        type: 'text',
                        text: ', just a heads-up that your subscription will renew automatically. Here are the details so there are no surprises:',
                    },
                ],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', marks: [{ type: 'bold' }], text: 'Plan: ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'subscriptionPlan',
                            label: 'subscriptionPlan',
                            fallback: '',
                            required: false,
                        },
                    },
                    { type: 'hardBreak' },
                    { type: 'text', marks: [{ type: 'bold' }], text: 'Amount: ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'subscriptionAmount',
                            label: 'subscriptionAmount',
                            fallback: '',
                            required: false,
                        },
                    },
                    { type: 'hardBreak' },
                    { type: 'text', marks: [{ type: 'bold' }], text: 'Renews on: ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'nextBillingDate',
                            label: 'nextBillingDate',
                            fallback: '',
                            required: false,
                        },
                    },
                ],
            },
            {
                type: 'emailButton',
                attrs: {
                    text: 'Manage subscription',
                    url: '{{ customerPortalUrl }}',
                    align: 'left',
                    variant: 'filled',
                    radius: 'smooth',
                    bgColor: '#0284c7',
                    textColor: '#ffffff',
                },
            },
            { type: 'emailSpacer', attrs: { height: 12 } },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'No action needed if everything looks right — the charge happens automatically. Questions? Reply to this email, we read every one.',
                    },
                ],
            },
        ],
    },
}
